import React from 'react'
import { inject, track } from '@vercel/analytics'

type AllowedPropertyValue = string | number | boolean | null

type TrackProperties = Record<string, AllowedPropertyValue>

export function trackVercelEvent(name: string, properties?: TrackProperties) {
  return track?.(name, properties)
}

export const VercelAnalytics = () => {
  React.useLayoutEffect(() => {
    inject()
  }, [])
  return null
}
